import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { StreamingLeftNavigationService } from '../features/navigation/left-navigation.service';

@Component({
    selector: 'craig-streaming-view',
    templateUrl: './streaming-view.component.html',
    styleUrls: ['./streaming-view.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StreamingViewComponent implements OnInit, OnDestroy {
    queryShowed: boolean = false;

    private readonly componentDestroyed$: Subject<boolean> = new Subject();

    constructor(
        private readonly leftNavigationService: StreamingLeftNavigationService,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.leftNavigationService
            .chatShowedChange()
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((showChat: boolean) => {
                // console.log('🎯 🔥🔥🔥🔥🔥🔥 [StreamingViewComponent] Received showConversation change:', showChat);
                if (showChat) {
                    // console.log('🎯 [StreamingViewComponent] Showing conversation');
                    this.queryShowed = true;

                    // Track streaming view entry for funnel analysis
                    this.trackStreamingViewEntry();
                } else {
                    // console.log('🎯 [StreamingViewComponent] Hiding conversation');
                    this.queryShowed = false;
                    this.leftNavigationService.selectChatSession(null);
                }

                // console.log('🎯 [StreamingViewComponent] queryShowed is now:', this.queryShowed);
                this.changeDetectorRef.detectChanges();
            });

        this.leftNavigationService
            .chatSessionSelectedChange()
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((sessionId: number | null) => {
                // console.log('🔍 [StreamingViewComponent] Received conversationSessionSelectedChange:', sessionId);
                if (sessionId) {
                    // console.log('🔍 [StreamingViewComponent] Showing conversation for session:', sessionId);
                    this.queryShowed = true;
                    this.changeDetectorRef.detectChanges();
                } else {
                    // console.log('🔍 [StreamingViewComponent] Session is null, no action taken');
                }
            });
    }

    ngOnDestroy(): void {
        this.componentDestroyed$.next(true);
    }

    /**
     * Track streaming view entry event for New Relic funnel analysis
     */
    private trackStreamingViewEntry(): void {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newrelic = (window as any).newrelic;

        if (newrelic && newrelic.addPageAction) {
            newrelic.addPageAction('streaming_view_entry', {
                timestamp: new Date().toISOString(),
                sessionId: this.generateSessionId(),
                userAgent: navigator.userAgent,
                viewportSize: `${window.innerWidth}x${window.innerHeight}`,
                triggerSource: 'streaming_view_component_shown'
            });
        }
    }

    /**
     * Generate a session ID for tracking user sessions
     */
    private generateSessionId(): string {
        // Try to get existing session ID from localStorage, or create a new one
        const existingSessionId = localStorage.getItem('craig_session_id');
        if (existingSessionId) {
            return existingSessionId;
        }

        const sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        localStorage.setItem('craig_session_id', sessionId);
        return sessionId;
    }
}
